<form [formGroup]="technicianForm" (ngSubmit)="onSubmit()">

  <mat-dialog-content class="mat-typography">
    <div class="d-flex align-items-center justify-content-between m-b-16">
      <h4 class="f-s-16 f-w-600 m-b-16">{{ "technicians.technician_profile" | translate }}</h4>
      <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
      </button>
    </div>
    <div class="row m-t-24">
      <div class="col-sm-12">
        <mat-label class="f-w-600  d-block">{{ "personal_details.name" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint  m-b-8">
          <input type="text" matInput id="name" formControlName="name" [readOnly]="readonly"/>
        </mat-form-field>
        @if (technicianForm.get('name')?.hasError('required') && technicianForm.get('name')?.touched) {
          <mat-error>
            {{ "personal_details.name_required" | translate }}
          </mat-error>
        }
      </div>

      <div class="col-sm-12">
        <mat-label class="f-w-600  d-block">{{ "personal_details.lastname" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint  m-b-8">
          <input type="text" matInput id="lastname" formControlName="lastname" [readOnly]="readonly" />
        </mat-form-field>
        @if (technicianForm.get('lastname')?.hasError('required') && technicianForm.get('lastname')?.touched) {
          <mat-error>
            {{ "personal_details.lastname_required" | translate }}
          </mat-error>
        }
      </div>

      <div class="col-sm-12">
        <mat-label class="f-w-600  d-block">{{ "personal_details.email" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint  m-b-8">
          <input type="email" matInput id="email" formControlName="email" [readOnly]="readonly" />
        </mat-form-field>
        @if (technicianForm.get('email')?.hasError('required') && technicianForm.get('email')?.touched) {
          <mat-error>
            {{ 'login.email_required' | translate }}
          </mat-error>
        }
        @if (technicianForm.get('email')?.hasError('email') && technicianForm.get('email')?.touched) {
          <mat-error>
            {{ 'login.invalid_email' | translate }}
          </mat-error>
        }
      </div>

      <div class="col-sm-12">
        <mat-label class="f-w-600  d-block">{{ "personal_details.role" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint  m-b-8">
          <input type="text" matInput id="roles" formControlName="roles" [value]="technicianRoleName" readonly/>
        </mat-form-field>
      </div>

      <div class="col-sm-12">
        <mat-label class="f-w-600  d-block">{{ "personal_details.company" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint  m-b-8">
          <mat-select formControlName="company" id="company" (openedChange)="onCompanyDropdownOpened($event)" [disabled]="readonly">
            <mat-option>
              <input matInput #companyFilterInput placeholder="{{ 'search' | translate }}" [(ngModel)]="companyFilter"
                     [ngModelOptions]="{ standalone: true }" (click)="$event.stopPropagation()"/>
            </mat-option>
            <mat-option *ngFor="let company of filteredCompanies()" [value]="company.id">
              {{ company.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        @if (technicianForm.get('company')?.hasError('required') && technicianForm.get('company')?.touched) {
          <mat-error>
            {{ "personal_details.company_required" | translate }}
          </mat-error>
        }
      </div>

      <div class="col-sm-5">
        <mat-label class="f-s-14 f-w-600  d-block">{{ "personal_details.prefix" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint  m-b-8" color="primary">
          <mat-select formControlName="prefix" id="prefix" (openedChange)="onPrefixDropdownOpened($event)" [disabled]="readonly">
            <mat-option>
              <input matInput #filterInput placeholder="{{ 'search' | translate }}" [(ngModel)]="prefixFilter" [readOnly]="readonly"
                     [ngModelOptions]="{ standalone: true }" (click)="$event.stopPropagation()"/>
            </mat-option>
            <mat-option *ngFor="let prefix of filteredPrefixes()" [value]="prefix.id">
              {{ prefix.prefix }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-sm-7">
        <mat-label class="f-s-14 f-w-600  d-block">{{ "personal_details.phone" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100 hide-hint  m-b-8" color="primary">
          <input type="tel" matInput formControlName="phone" id="phone" (input)="onPhoneInput($event)" [readOnly]="readonly"/>
          @if (technicianForm.controls['phone'].hasError('invalidPhone')) {
            <mat-error>
              {{ "personal_details.phone_validator" | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-divider></mat-divider>
  @if (user && user.roles && user.roles.id < Roles.OPERATOR_BO) {
  <mat-dialog-actions class="d-flex justify-content-between align-items-center w-100 gap-8">
    <div class="d-flex align-items-center gap-8">
      @if (canDelete) {
        <button type="button" mat-stroked-button class="text-error border-error" (click)="deleteTechnician()">
          <span class="d-flex align-items-center justify-content-center gap-4 text-nowrap">
            <i-tabler name="trash" class="icon-18"></i-tabler>
            {{ "technicians.delete" | translate }}
          </span>
        </button>
      }
    </div>
    <div class="d-flex align-items-center gap-8">
      <button mat-flat-button type="submit" [disabled]="!technicianForm.valid" color="primary">
        {{ "personal_details.save" | translate }}
      </button>
      <button mat-flat-button class="bg-error text-white" mat-dialog-close>
        {{ "personal_details.close" | translate }}
      </button>
    </div>
  </mat-dialog-actions>
  }
</form>
